var React = require('react');

function TemperatureDown (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M256,278.5V112a112,112,0,0,0-224,0V278.5C12.3,303.19,0,334,0,368a144,144,0,0,0,288,0C288,334,275.7,303.09,256,278.5ZM144,448A79.87,79.87,0,0,1,96,304.19V112a48,48,0,0,1,96,0V304.19A79.87,79.87,0,0,1,144,448Z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M160,322.91V304a16,16,0,0,0-32,0v18.91a48,48,0,1,0,32,0ZM496,352H448V48a16,16,0,0,0-16-16H400a16,16,0,0,0-16,16V352H336c-14.2,0-21.39,17.25-11.31,27.31l80,96a16,16,0,0,0,22.62,0l80-96C517.34,369.25,510.22,352,496,352Z","className":"fa-primary","key":2})]);
}

TemperatureDown.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = TemperatureDown;

TemperatureDown.default = TemperatureDown;
